import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxconfirmation';
export const route = 'cnxconfirmation/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxconfirmation" */
/* webpackPrefetch: true */
'../components/ConfirmationPage')));